import React, { useState, useEffect } from 'react';
import { SocialEventContext } from './DataContext';
import axios from "axios";
import config from '../components/configuration/config';

export const SocialEventState = ({ children }) => {
    const [agendaSocialData, setAgendaSocialData] = useState(null);
    const [error, setError] = useState(null);
    const [socialSessionId, setSocialSessionId] = useState(config.defaultSocialSessionId || 198);
    const isEvent = config.currentEventID;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`https://apievt.lacnic.net/wp-json/wp/v2/agenda`, {
                    params: {
                        per_page: 100,
                        agenda_sessions: socialSessionId,
                        our_events: isEvent
                    }
                });
                setAgendaSocialData(response?.data?.[0] || null);
                setError(null);
            } catch (error) {
                setError(error.message);
                setAgendaSocialData(null);
            }
        };
        fetchData();
    }, [socialSessionId, isEvent]);

    const handleSocialId = (id) => setSocialSessionId(id);

    const [socialExists, setSocialExists] = useState({
        runnersExists: false,
        cocktailExists: false,
        socialEventExists: false
    });

    useEffect(() => {
        const fetchSocialEvents = async () => {
            try {
                const responses = await Promise.all([
                    axios.get('https://apievt.lacnic.net/wp-json/wp/v2/agenda', { params: { per_page: 100, agenda_sessions: 198, our_events: isEvent } }),
                    axios.get('https://apievt.lacnic.net/wp-json/wp/v2/agenda', { params: { per_page: 100, agenda_sessions: 199, our_events: isEvent } }),
                    axios.get('https://apievt.lacnic.net/wp-json/wp/v2/agenda', { params: { per_page: 100, agenda_sessions: 200, our_events: isEvent } })
                ]);
                
                setSocialExists({
                    runnersExists: responses[0].data.length > 0,
                    cocktailExists: responses[1].data.length > 0,
                    socialEventExists: responses[2].data.length > 0
                });
            } catch (error) {
                console.error('Error fetching social events:', error);
                setError(error.message);
            }
        };

        fetchSocialEvents();
    }, [isEvent]);

    return (
        <SocialEventContext.Provider value={{ 
            agendaSocialData, error, socialSessionId, handleSocialId, socialExists
        }}>
            {children}
        </SocialEventContext.Provider>
    );
}